import { environment } from '../../environments/environment';
const restBaseURLDomain = environment.restBaseURL
    .replace(/http(s*):\/\//, '');

const favouritesUrl = environment.favouritesHost
    .replace(/http(s*):\/\//, '');

const csBaseUrl = environment.csBaseURL
    .replace(/http(s*):\/\//, '');

export const whiteListedPaths = [
    // environment.apiServicesDomain + '/catalogue/category'
    `${csBaseUrl}`,
    `${favouritesUrl}${environment.favouriteBaseURL}`,
    `${favouritesUrl}/favourite`,
    `${restBaseURLDomain}`,
    '/orders',
    '/place-order'
];

export const noHeadersPaths = [
    /.*nzpost\.co\.nz.*/
];
